"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var AbstractCalculator = /*#__PURE__*/(0, _createClass2.default)(function AbstractCalculator() {
  (0, _classCallCheck2.default)(this, AbstractCalculator);
});
var _default = exports.default = AbstractCalculator;